var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "regReportUpgradeModal",
        role: "dialog",
        "data-backdrop": "static",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog upgrade-account-modal" }, [
        _c("div", { staticClass: "modal-content first-modal-content" }, [
          _c("div", { staticClass: "modal-header upgradeModal-bgcolor" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "data-target": "#UpgradeModal" },
                on: { click: _vm.closePopup },
              },
              [_vm._v(" × ")]
            ),
            _vm._m(0),
          ]),
          _c("div", { staticClass: "modal-body confirm-body" }, [
            _vm._m(1),
            _vm._m(2),
            _c("div", { staticClass: "row m-0" }, [
              _c("div", { staticClass: "col-xs-6 text-left service-header" }, [
                _c("p", [_vm._v(_vm._s(_vm.selectedService.name))]),
                _c("p", { staticClass: "service-description pl-10" }, [
                  _c("span", [_vm._v("Renews")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("dateFormat")(_vm.selectedService.valid_until)
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "col-xs-6 text-right" }, [
                _vm._v(" $" + _vm._s(_vm.selectedService.price)),
                _c("span", { staticClass: "service-description" }, [
                  _vm._v(" per year"),
                ]),
              ]),
            ]),
            _vm._m(3),
            _vm._m(4),
            _vm._m(5),
            _vm._m(6),
          ]),
          _c("div", { staticClass: "modal-footer cancelModal-bgcolor" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-lg-6 col-sm-6 col-md-6 pl-0 text-left please-cancel-btn",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block emergo-white-button",
                    on: {
                      click: function ($event) {
                        return _vm.closePopup()
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "col-lg-6 col-sm-6 col-md-6 pr-0 text-right" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block emergo-green-button",
                    on: {
                      click: function ($event) {
                        return _vm.upgradeService()
                      },
                    },
                  },
                  [_vm._v(" Upgrade Service ")]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-title" }, [
      _c("div", { staticClass: "upgrade-service-para fw-400" }, [
        _vm._v("Upgrade Service"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row m-0" }, [
      _c("div", { staticClass: "col-sm-6 text-left" }, [
        _vm._v("Current Service"),
      ]),
      _c("div", { staticClass: "col-sm-6 text-right" }, [
        _vm._v("Current Price"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row col-xs-12 m-0" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row col-xs-12 m-0" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row m-0" }, [
      _c("div", { staticClass: "col-sm-6 text-left" }, [
        _vm._v("Upgrade Service"),
      ]),
      _c("div", { staticClass: "col-sm-6 text-right" }, [
        _vm._v("Additional Price"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row col-xs-12 m-0" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row m-0" }, [
      _c("div", { staticClass: "col-xs-10 text-left service-header" }, [
        _c("ul", { staticClass: "service-description pl-20" }, [
          _c("li", { staticClass: "pb-10" }, [
            _vm._v("Includes unlimited reports"),
          ]),
          _c("li", { staticClass: "pb-10" }, [
            _vm._v(
              "Upgrading will restart the clock and give a pro-rated credit"
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "col-xs-2 text-right" }, [_vm._v("+$1000")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }